import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import { connect } from 'react-redux'
import ImmutableProptypes from 'react-immutable-proptypes'
import { OrderedMap, List } from 'immutable'
import { browserHistory } from 'react-router'
import Moment from 'moment'
import Modal from 'react-modal'
import { CSVLink } from 'react-csv'

import CategoryTabs from '_components/categoryTabs'
import DurationInput from '_components/durationInput'
import DatetimeInput from '_components/datetimeInput'
import Icon from '_components/icon'
import { updateLastActivityAt } from '_modules/user/actions'
import { getNonTasks } from '_modules/non-task/actions'
import { clearNotifications } from '_modules/notification/actions'
import { getTasks, addToLog, deleteFromLog } from '_modules/log/actions'
import { updateTaskStatus, startTask } from '_modules/current-task/actions'
import { decrementCounter, startTimer } from '_modules/counter/actions'
import { getEngagementEntries } from '_modules/engagement/actions'
import { sortByLastOccurenceAt } from '_utils/sort'
import { getCounterValue, getMindfulBreakDuration } from '_utils/counter'
import { planTypes } from '_utils/planType'
import { iconForTaskStatus } from '_utils/icon'
import { USER_STATUS_TYPES } from '_utils/userStatusType'
import Socket from '_utils/socket'
import { BACKEND_URL } from '_config/environment'
import { objectToArray, createFieldMissingErrorMessage, deepCopyJSON } from '_utils/helperFunction'

import Summary from '../summary'
import NonTaskReflection from '../nonTaskReflection'
import EngagementReflection from '../engagementReflection'
import ExportOptionsModal from './export-options-modal'

import styles from './styles.css'

const mapStateToProps = ({ user, log, counter, mindfulBreaks, engagement, settings }) => ({
  user,
  log,
  counter,
  mindfulBreaks,
  engagements: engagement,
  settings,
})

const mapDispatchToProps = {
  getTasks,
  decrementCounter,
  updateTaskStatus,
  startTimer,
  startTask,
  getEngagementEntries,
  addToLog,
  clearNotifications,
  deleteFromLog,
  updateLastActivityAt,
  getNonTasks,
}

class LogList extends PureComponent {
  static propTypes = {
    user: ImmutableProptypes.map,
    engagements: ImmutableProptypes.map,
    log: ImmutableProptypes.orderedMap,
    counter: ImmutableProptypes.map,
    mindfulBreaks: ImmutableProptypes.map,
    settings: ImmutableProptypes.map,
    getTasks: PropTypes.func.isRequired,
    decrementCounter: PropTypes.func.isRequired,
    updateTaskStatus: PropTypes.func.isRequired,
    startTimer: PropTypes.func.isRequired,
    startTask: PropTypes.func.isRequired,
    getEngagementEntries: PropTypes.func.isRequired,
    addToLog: PropTypes.func.isRequired,
    clearNotifications: PropTypes.func.isRequired,
    deleteFromLog: PropTypes.func.isRequired,
    updateLastActivityAt: PropTypes.func.isRequired,
    getNonTasks: PropTypes.func.isRequired,
  }

  static defaultProps = {
    user: new Map(),
    log: new OrderedMap(),
    counter: new Map(),
    mindfulBreaks: new Map(),
    engagements: new Map(),
    settings: new Map(),
    currentTask: new Map(),
  }

  state = {
    showMore: false,
    isModalOpen: false,
    summary: false,
    showEngagement: false,
    addNew: false,
    planType: 100,
    modalName: '',
    modalDuration: 0,
    modalDate: null,
    showReflect: false,
    showExport: false,
    selectedOption: { value: 100, label: 'Time Sheet', columns: 'Task Name, Total Time (H)' },
    selectedDateRange: 100,
    selectedDateRangeStart: Moment().startOf('day'),
    selectedDateRangeEnd: Moment().endOf('day'),
    csvData: [],
    csvFilename: 'log',
  }

  componentWillMount() {
    Modal.setAppElement('body')
    const { user } = this.props
    this.setState({
      planType: user.get('planType', 100) * 1,
    })
  }

  componentDidMount() {
    this.props.getTasks()
    this.props.getEngagementEntries()
    this.props.getNonTasks()
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      planType: nextProps.user.get('planType', 100) * 1,
    })
    if (this.props.user.get('lastActivityAt') !== nextProps.user.get('lastActivityAt')) {
      this.props.getEngagementEntries()
      this.props.getTasks()
    }
  }

  onDeleteClick = e => {
    e.stopPropagation()
    const { id, name } = e.currentTarget

    this.props.deleteFromLog({ taskId: id })
  }

  onPlayClick = event => {
    event.stopPropagation()

    const { id, name } = event.currentTarget
    const { counter, log, mindfulBreaks, settings } = this.props

    // if current task, dont play
    if (counter.get('intervalId') !== null) return

    // update last occurence in log
    const task = log.get(id)

    if (task.getIn(['occurences', -1, 'status']) !== 2) {
      this.props.updateTaskStatus(id)
    }

    const flexibleTime = settings.get('flexibleTime')

    browserHistory.push({
      pathname: '/',
      state: {
        name,
        action: 'start',
        logEntry: id,
        flexibleTime,
        type: 1,
      },
    })
  }

  onLogClick = event => {
    const { id } = event.currentTarget
    browserHistory.push({
      pathname: '/log',
      query: {
        id,
      },
    })
  }

  onShowMoreClick = () => {
    this.setState({
      showMore: !this.state.showMore,
    })
  }

  onAddNewClick = () => {
    this.setState(
      {
        addNew: true,
        isModalOpen: true,
        modalDate: Moment().subtract(60, 'minutes'),
        modalDuration: 60,
      },
      () => {
        this.nameInput.focus()
      }
    )
  }

  onSummaryClick = () => {
    this.checkLock()
    this.setState({
      summary: true,
      isModalOpen: true,
    })
  }

  onReflectClick = () => {
    this.checkLock()
    this.setState({
      showReflect: true,
      isModalOpen: true,
    })
  }

  onExportClick = () => {
    this.setState({
      showExport: true,
      isModalOpen: true,
    })
  }

  onConfirmExport = (event, done) => {
    const { selectedDateRangeEnd, selectedDateRangeStart, selectedOption } = this.state

    // TODO: call different api if selected options different
    const startDate = selectedDateRangeStart.format()
    const endDate = selectedDateRangeEnd.format()

    // if time sheet
    if (selectedOption.value === 100) {
      const csvFilename = `Timesheet ${selectedDateRangeStart.format(
        'M/D/YY'
      )} - ${selectedDateRangeEnd.format('M/D/YY')}.csv`

      fetch(`${BACKEND_URL || 'http://localhost:3000'}/api/tasks/timesheet`, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${this.props.user.get('token')}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ startDate, endDate }),
      })
        .then(res => res.json())
        .then(csvData => {
          this.setState(
            {
              csvData,
              csvFilename,
            },
            () => {
              if (this.csvLink) {
                this.csvLink.link.click()
                this.resetModal()
              }
            }
          )
        })
        .catch(err => console.log(err))
    } else {
      // if time details
      const csvFilename = `Timesheet Details ${selectedDateRangeStart.format(
        'M/D/YY'
      )} - ${selectedDateRangeEnd.format('M/D/YY')}.csv`

      fetch(`${BACKEND_URL || 'http://localhost:3000'}/api/tasks/timedetails`, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${this.props.user.get('token')}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ startDate, endDate }),
      })
        .then(res => res.json())
        .then(csvData => {
          this.setState(
            {
              csvData,
              csvFilename,
            },
            () => {
              if (this.csvLink) {
                this.csvLink.link.click()
                this.resetModal()
              }
            }
          )
        })
        .catch(err => console.log(err))
    }
  }

  onKeyPress = event => {
    if (event.key === 'Enter') {
      this.onConfirmModal()
    }
  }

  onConfirmModal = () => {
    const { modalName: name, modalDuration: duration, modalDate: date } = this.state

    if (!name || !duration || !date) {
      this.props.displayError(createFieldMissingErrorMessage({ name, duration, date }))

      return
    }
    this.props.addToLog({ name, type: 5, duration, startedAt: date })
    this.resetModal()

    // updateLastActivityAt
    this.props.updateLastActivityAt({
      lastActivityAt: new Date(),
    })
  }

  onCancelModal = () => {
    this.resetModal()
  }

  onModalChange = e => {
    e.preventDefault()

    let { id, value } = e.target

    this.setState({
      [id]: value,
    })
  }

  onDurationChange = modalDuration => {
    this.setState({ modalDuration })
  }

  onModalDateChange = modalDate => {
    this.setState({ modalDate })
  }

  checkLock = () => {
    const { planType } = this.state
    if (planType < planTypes.pro) {
      browserHistory.push('/subscribe')
    }
  }

  handleChange = selectedOption => {
    this.setState({ selectedOption, modalSection: selectedOption.section })
  }

  handleOptionClick = option => {
    this.setState({
      selectedDateRange: option.value,
      selectedDateRangeStart: option.startDate,
      selectedDateRangeEnd: option.endDate,
    })
  }

  timer = () => {
    this.props.decrementCounter()
  }

  toggleModal = () => {
    this.setState({
      isModalOpen: !this.state.isModalOpen,
    })
  }

  resetModal = () => {
    this.setState({
      isModalOpen: false,
      summary: false,
      showEngagement: false,
      addNew: false,
      modalName: '',
      modalDuration: 0,
      showReflect: false,
      modalDate: null,
      showExport: false,
      selectedOption: { value: 100, label: 'Time Sheet', columns: 'Task Name, Total Time (H)' },
      selectedDateRange: 100,
      selectedDateRangeStart: Moment().startOf('day'),
      selectedDateRangeEnd: Moment().endOf('day'),
      csvData: [],
      csvFilename: 'log',
    })
  }

  groupLogByDate = log =>
    log.reduce((groups, item) => {
      const day = Moment(item.get('startedAt')).format('YYYY-MM-DD')
      if (groups.get(day)) {
        return groups.set(day, groups.get(day).push(item))
      }
      return groups.set(day, List.of(item))
    }, new OrderedMap())

  renderTask = task => {
    const lastStatus = task.getIn(['occurences', -1, 'status'])
    const iconName = iconForTaskStatus(lastStatus)
    const playButtonDisabled = this.props.counter.get('status') === 'in progress'
    let iconNumber = Math.ceil(
      Moment(task.getIn(['occurences', -1, 'endedAt'])).diff(
        task.getIn(['occurences', -1, 'startedAt']),
        'minutes'
      ) / 15
    )
    if (iconNumber > 30) iconNumber = 30

    return (
      <li className={classnames(styles['Grid-cell'], styles.task)} key={task.get('_id')}>
        <div
          id={task.get('_id')}
          onClick={this.onLogClick}
          role="presentation"
          className={classnames(styles.Grid, styles['Grid--alignMiddle'])}
        >
          <span className={classnames(styles['Grid-cell'], styles['u-sizeFit'], styles.status)}>
            {lastStatus === 5 ? (
              <div className={styles.letterIcon}>M</div>
            ) : (
              <Icon type={iconName} isButton={false} />
            )}
          </span>
          <span className={classnames(styles['Grid-cell'], styles['u-sizeFill'], styles.name)}>
            {task.get('name')}
          </span>
          <span className={classnames(styles['Grid-cell'], styles['u-sizeFit'], styles.occurences)}>
            {lastStatus === 5
              ? [...Array(iconNumber)].map((e, i) => (
                  <i key={i} className={classnames('fa fa-circle', styles.occurence)} />
                ))
              : task
                  .get('occurences')
                  .map(occ => (
                    <i
                      key={occ.get('_id')}
                      className={classnames('fa fa-circle', styles.occurence)}
                    />
                  ))}
          </span>
          {lastStatus !== 5 ? (
            <button
              id={task.get('_id')}
              className={classnames(styles['Grid-cell'], styles['u-sizeFit'], styles.button)}
              name={task.get('name')}
              disabled={playButtonDisabled}
              onClick={this.onPlayClick}
            >
              <i
                className={classnames('fa fa-play', [playButtonDisabled && styles.disabledButton])}
              />
            </button>
          ) : (
            <button
              id={task.get('_id')}
              className={classnames(styles['Grid-cell'], styles['u-sizeFit'], styles.button)}
              name={task.get('name')}
              onClick={this.onDeleteClick}
            >
              <i className={classnames('fa fa-trash')} />
            </button>
          )}
        </div>
      </li>
    )
  }

  renderTaskGroup = (groups, date) => {
    if (!this.state.showMore && date !== Moment(new Date()).format('YYYY-MM-DD')) {
      return null
    }
    return (
      <li key={date} className={classnames(styles.Grid, styles['Grid--alignCenter'])}>
        {Moment().format('YYYY-MM-DD') !== Moment(date).format('YYYY-MM-DD') && (
          <div className={classnames(styles['Grid-cell'], styles.date)}>
            {Moment(date).calendar(null, {
              sameDay: '[Today]',
              nextDay: '[Tomorrow]',
              nextWeek: 'MMM Do',
              lastDay: '[Yesterday]',
              lastWeek: 'MMM Do',
              sameElse: 'MMM Do',
            })}
          </div>
        )}
        <ul>{groups.map(task => this.renderTask(task))}</ul>
      </li>
    )
  }

  render() {
    const { log } = this.props
    const {
      isModalOpen,
      planType,
      addNew,
      modalName,
      modalDuration,
      modalDate,
      showReflect,
      showExport,
      selectedOption,
      selectedDateRange,
      csvData,
      csvFilename,
    } = this.state

    const customStyles = {
      control: (provided, state) => ({
        ...provided,
        backgroundColor: 'auto',
        border: ' 1px solid rgba(255,255,255,0.3)',
      }),
      placeholder: (provided, state) => ({ ...provided, fontSize: 16, color: 'white' }),
      singleValue: (provided, state) => ({ ...provided, fontSize: 16, color: 'white' }),
      input: (provided, state) => ({ ...provided, fontSize: 16, color: 'white' }),
      menu: (provided, state) => ({
        ...provided,
        backgroundColor: 'rgba(80,95,172,0.8)',
        fontSize: 16,
        color: 'white',
      }),
      option: (provided, { isFocused }) => {
        return {
          ...provided,
          color: isFocused ? 'black' : 'white',
        }
      },
    }

    const selectOptions = [
      { value: 100, label: 'Time Sheet', columns: 'Task Name, Total Time (H)' },
      {
        value: 200,
        label: 'Time Sheet Details',
        columns: 'Task Name, Date, Start Time, End Time, Duration',
      },
    ]

    const dateRangeOptions = [
      {
        label: 'Today',
        startDate: Moment().startOf('day'),
        endDate: Moment().endOf('day'),
        value: 100,
      },
      {
        label: 'Past 7 Days',
        startDate: Moment()
          .subtract(7, 'days')
          .startOf('day'),
        endDate: Moment().endOf('day'),
        value: 200,
      },
      {
        label: 'Past 30 Days',
        startDate: Moment()
          .subtract(30, 'days')
          .startOf('day'),
        endDate: Moment().endOf('day'),
        value: 300,
      },
    ]

    const groupedLog = this.groupLogByDate(log.sort(sortByLastOccurenceAt))
    return (
      <div
        ref={div => (this.divRef = div)}
        className={classnames(styles.Grid, styles['Grid--alignCenter'], styles.main)}
      >
        <div className={classnames(styles['Grid-cell'], styles['list-container'])}>
          {groupedLog.size > 0 ? (
            <ul className={classnames(styles.list)}>
              <div className={classnames(styles['Grid-cell'], styles.date)}>
                {this.state.showMore ? 'Logs From the Last 30 Days' : "Today's Log"}
              </div>
              {groupedLog
                .valueSeq()
                .map((groups, index) =>
                  this.renderTaskGroup(groups, groupedLog.keySeq().toArray()[index])
                )}
            </ul>
          ) : (
            <p className={classnames(styles.date)}>You have no logs</p>
          )}
        </div>
        <div className={classnames(styles['Grid-cell'], styles['u-sizeFit'])}>
          <button className={classnames(styles['show-more'])} onClick={this.onAddNewClick}>
            Add New
          </button>
          <button className={classnames(styles['show-more'])} onClick={this.onShowMoreClick}>
            {this.state.showMore ? 'Show Less' : 'Show More'}
          </button>
          <button className={classnames(styles['show-more'])} onClick={this.onReflectClick}>
            Reflect {planType < planTypes.pro && <i className={classnames('fa fa-lock')} />}
          </button>
          <button className={classnames(styles['show-more'])} onClick={this.onExportClick}>
            Export
          </button>
        </div>
        <CSVLink
          data={csvData}
          ref={ele => (this.csvLink = ele)}
          filename={csvFilename}
          target="_blank"
          uFEFF={false}
        />
        <Modal
          isOpen={isModalOpen}
          className={classnames(styles.modal)}
          overlayClassName={classnames(styles.overlay)}
          onRequestClose={this.resetModal}
          bodyOpenClassName={classnames(styles['disable-body-scroll'])}
        >
          <div>
            {showReflect && (
              <CategoryTabs isOpen={showReflect} closePlusForm={this.closePlusForm}>
                <Summary />
                <NonTaskReflection type={2} />
                <NonTaskReflection type={1} />
                <EngagementReflection />
              </CategoryTabs>
            )}
            {showExport && (
              <ExportOptionsModal
                selectValue={selectedOption}
                selectOnChange={this.handleChange}
                selectOptions={selectOptions}
                selectCustomStyles={customStyles}
                placeholder={'Select Type'}
                button1Name="CANCEL"
                button1Function={this.resetModal}
                button2Name="EXPORT"
                button2Function={this.onConfirmExport}
                dateRangeOptions={dateRangeOptions}
                handleOptionClick={this.handleOptionClick}
                selectedDateRange={selectedDateRange}
                csvData={csvData}
                csvFilename={csvFilename}
              />
            )}
            {addNew && (
              <div
                className={classnames(styles.Grid, styles['Grid--alignCenter'])}
                style={{ padding: '20px 0' }}
              >
                <input
                  ref={input => {
                    this.nameInput = input
                  }}
                  type="text"
                  id="modalName"
                  placeholder="Name"
                  value={modalName}
                  onChange={this.onModalChange}
                  className={classnames(styles['Grid-cell'], styles['u-sizeFit'], styles.input)}
                  onKeyPress={this.onKeyPress}
                />
                <DurationInput
                  type="text"
                  id="modalDuration"
                  placeholder="Duration in Minutes"
                  value={modalDuration}
                  onChange={this.onDurationChange}
                  className={classnames(styles['Grid-cell'], styles['u-sizeFit'], styles.input)}
                  onKeyPress={this.onKeyPress}
                />
                <DatetimeInput
                  type="text"
                  id="modalDate"
                  placeholder="Date and Time"
                  value={modalDate}
                  onChange={this.onModalDateChange}
                  className={classnames(styles['Grid-cell'], styles['u-sizeFit'], styles.input)}
                  onKeyPress={this.onKeyPress}
                />

                <button
                  onClick={this.onConfirmModal}
                  className={classnames(
                    styles['Grid-cell'],
                    styles['u-sizeFit'],
                    styles.modalButton
                  )}
                >
                  SAVE
                </button>
                <button
                  onClick={this.onCancelModal}
                  className={classnames(
                    styles['Grid-cell'],
                    styles['u-sizeFit'],
                    styles.modalButton
                  )}
                >
                  CANCEL
                </button>
              </div>
            )}
          </div>
        </Modal>
      </div>
    )
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LogList)



// WEBPACK FOOTER //
// ./src/views/log/list/index.js